<template>
  <div>
    <form-component
      :navigation-group="navigationGroup"
      :product-subcategories="productSubcategories"
      @onSubmit="onSubmit" />
  </div>
</template>

<script>
import FormComponent from '@/components/navigation/FormComponent';
import NotificationMixin from '@/mixins/NotificationMixin';
import { updateOrCreate } from '@/http/navigation';
import { all } from '@/http/product/subcategory';

export default {
  mixins: [NotificationMixin],
  components: {
    FormComponent,
  },

  data() {
    return {
      navigationGroup: {
        name: '',
        slug: '',
        navigation_subgroups: [],
      },
      productSubcategories: [],
    };
  },

  async created() {
    await this.fetchProductSubcategories();
  },

  methods: {
    async fetchProductSubcategories() {
      try {
        const { data } = await all();
        this.productSubcategories = data.data;
      } catch (e) {
        this.showErrorNotification('Problem z pobraniem danych', 'Nie udało się pobrać danych podkategorii.');
      }
    },
    async onSubmit(data) {
      const form = new FormData();

      form.append('lang', data.lang);
      form.append('name', data.name);
      form.append('slug', data.slug);
      form.append('inspiration_link', data.inspiration_link);

      for (let i = 0; i < data.navigation_subgroups.length; i++) {
        form.append(`navigation_subgroups[${i}][name]`, data.navigation_subgroups[i].name);
        form.append(`navigation_subgroups[${i}][slug]`, data.navigation_subgroups[i].slug);

        for (let j = 0; j < data.navigation_subgroups[i].navigation_elements.length; j++) {
          form.append(
            `navigation_subgroups[${i}][navigation_elements][${j}][name]`,
            data.navigation_subgroups[i].navigation_elements[j].name,
          );
          form.append(
            `navigation_subgroups[${i}][navigation_elements][${j}][slug]`,
            data.navigation_subgroups[i].navigation_elements[j].slug,
          );

          for (let k = 0; k < data.navigation_subgroups[i].navigation_elements[j].categories.length; k++) {
            form.append(
              `navigation_subgroups[${i}][navigation_elements][${j}][categories][${k}][id]`,
              data.navigation_subgroups[i].navigation_elements[j].categories[k].id,
            );
          }
        }
      }
      form.append('main_image', data.main_image.file, data.main_image.file.fileName);

      try {
        await updateOrCreate(form);

        this.showSuccessNotification('Dane zapisane', 'Element nawigacji został dodany.');
        this.$router.push({ name: 'navigation-index' });
      } catch (error) {
        const message =
          error.response.data.message ??
          'Wystąpił błąd podczas dodawania elementu nawigacji. Skontaktuj się ze swoim developerem.';

        this.showErrorNotification('Problem z zapisaniem danych', message);
      }
    },
  },
};
</script>
